import React from 'react'
import CalendarItem from '../components/CalendarItem'
import '../styles/pages/Schedule.css'

export default function Schedule() {
  return (
    <div>
      <div className='calendar--container'>
        <CalendarItem />
      </div>
    </div>
  )
}
